import { Permission } from '../../entities/Permission/Permission'
import { PermissionSlug } from '../../types/permissionTypes'

const checkPermission = (permissions: Permission[], slug: PermissionSlug): boolean => permissions.some(permission => permission.slug === slug)

export default checkPermission
